import React from 'react';
import { Typography } from '@mui/material';
import ActiveIcon from '@mui/icons-material/CheckCircleOutline';
import PausedIcon from '@mui/icons-material/PauseCircleOutline';
import ExpiredIcon from '@mui/icons-material/WarningAmber';
import CanceledIcon from '@mui/icons-material/HighlightOff';

export function PlanStatus(props) {
  const { status } = props;
  return (
    <>
      <Typography>
        <b>Status</b>
      </Typography>
      {status === 'active' ? (
        <Typography sx={{ color: 'success.main' }}>
          <ActiveIcon style={{ verticalAlign: 'middle' }} /> Active
        </Typography>
      ) : status === 'active trial' ? (
        <Typography sx={{ color: 'success.main' }}>
          <ActiveIcon style={{ verticalAlign: 'middle' }} /> Active - Free Trial
        </Typography>
      ) : status === 'paused' ? (
        <Typography sx={{ color: 'warning.main' }}>
          <PausedIcon style={{ verticalAlign: 'middle' }} /> Paused
        </Typography>
      ) : status === 'canceled' ? (
        <Typography sx={{ color: 'error.main' }}>
          <CanceledIcon style={{ verticalAlign: 'middle' }} /> Canceled
        </Typography>
      ) : status === 'expired' ? (
        <Typography sx={{ color: 'error.main' }}>
          <ExpiredIcon style={{ verticalAlign: 'middle' }} /> No Subscription
        </Typography>
      ) : (
        <Typography>{status}</Typography>
      )}
    </>
  );
}
